import Immutable from 'immutable';
import { act } from 'react-dom/test-utils';

export const getTechRoutedStarted = (state) => {
    return state.set('workOrderDetails', state.get('workOrderDetails').map((order) => {
        return order.map((orderChildren) => {
            if (Immutable.Iterable.isIterable(orderChildren)) {
                return orderChildren.set('loading', false);
            }
            return orderChildren;
        });
    }));

};

export const getTechRouteFinished = (state, action) => {

    const assignedServiceOrders = Immutable
        .fromJS(action.payload)
        .get('assignedServiceOrders');

    if (!assignedServiceOrders) {
        return state;
    }

    assignedServiceOrders.forEach((order) => {

        const orderId = order.getIn(['serviceOrderInfoV2', 'serviceOrderId']);

        state = state.setIn([
            'workOrderDetails', orderId, 'schedulingSystemDetails', 'details'
        ], order);

        state = state.setIn([
            'workOrderDetails', orderId, 'schedulingSystemDetails', 'loading'
        ], false);

        state = state.setIn([
            'workOrderDetails', orderId, 'schedulingSystemDetails', 'loadingFinished'
        ], true);

    });

    return state;

};

export const workOrderTransferStarted = (state, action) => {
    state = state.setIn(['workOrderTransferSubmitting'], true)
            .setIn(['workOrderTransferError'], null)
            .setIn(['workOrderTransferSuccess'], null);

    return state;
};

export const workOrderTransferFinished = (state, action) => {
    state = state.setIn(['workOrderTransferSubmitting'], false)
    .setIn(['workOrderTransferError'], action.payload.message)
    .setIn(['workOrderTransferSuccess'], action.payload.success);

    return state
};

export const workOrderTransferFailed = (state, action) => {
    state = state.setIn(['workOrderTransferSubmitting'], false)
    .setIn(['workOrderTransferError'], action.error.message)
    .setIn(['workOrderTransferSuccess'], action.error.success);
    
    return state;
};

export const clearWorkOrderTransferState = (state, action) => {
    state = state.setIn(['workOrderTransferSubmitting'], false)
    .setIn(['workOrderTransferError'], null)
    .setIn(['workOrderTransferSuccess'], null);
    
    return state;
};


// WEBPACK FOOTER //
// ./src/reducers/work-order/techRoute.js